export const CDN_URL =
  "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_508,h_320,c_fill/";

export const SWIGGY_LIVE_API =
  "https://corsproxy.io/?https://www.swiggy.com/dapi/restaurants/list/v5?lat=31.3496597&lng=75.5937967&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING";

export const FETCH_MENU_URL =
  "https://corsproxy.io/?https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=31.3496597&lng=75.5937967&restaurantId=";

export const FETCH_MENU_URL_MOBILE =
  "https://www.swiggy.com/mapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=31.3496597&lng=75.5937967&submitAction=ENTER&restaurantId=283662";

export const DELIVERY_TIME_URL =
  "https://www.swiggy.com/dapi/restaurants/list/v5?lat=25.3174112&lng=82.9738892&sortBy=DELIVERY_TIME&page_type=DESKTOP_WEB_LISTING";

export const RELEVENCE_URL =
  "https://www.swiggy.com/dapi/restaurants/list/v5?lat=25.3174112&lng=82.9738892&offset=20&sortBy=RELEVANCE&pageType=SEE_ALL&page_type=DESKTOP_SEE_ALL_LISTING";

export const RATING_URL =
  "https://www.swiggy.com/dapi/restaurants/list/v5?lat=25.3174112&lng=82.9738892&sortBy=RATING&page_type=DESKTOP_WEB_LISTING";

export const COST_LOW_HIGH_URL =
  "https://www.swiggy.com/dapi/restaurants/list/v5?lat=25.3174112&lng=82.9738892&sortBy=COST_FOR_TWO&page_type=DESKTOP_WEB_LISTING";

export const COST_HIGH_LOW_URL =
  "https://www.swiggy.com/dapi/restaurants/list/v5?lat=25.3174112&lng=82.9738892&sortBy=COST_FOR_TWO_H2L&page_type=DESKTOP_WEB_LISTING";

export const DEFAULT_DATA_URL =
  "https://corsproxy.io/?https://www.swiggy.com/dapi/restaurants/list/v5?lat=21.1702401&lng=72.83106070000001&page_type=DESKTOP_WEB_LISTING";

export const MENU_URL =
  "https://corsproxy.io/?https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=25.3174112&lng=82.9738892&restaurantId=";

export const FAQ = [
  {
    id: 473,
    title: "Can I edit my order?",
    description:
      "Your order can be edited before it reaches the restaurant. You could contact customer support team via chat or call to do so. Once order is placed and restaurant starts preparing your food, you may not edit its contents",
  },
  {
    id: 474,
    title: "I want to cancel my order",
    description:
      "We will do our best to accommodate your request if the order is not placed to the restaurant (Customer service number:  080-67466729). Please note that we will have a right to charge a cancellation fee up to full order value to compensate our restaurant and delivery partners if your order has been confirmed.",
  },
  {
    id: 475,
    title: "Will Insta Food be accountable for quality/quantity? ",
    description:
      "Quantity and quality of the food is the restaurants' responsibility. However in case of issues with the quality or quantity, kindly submit your feedback and we will pass it on to the restaurant.",
  },
  {
    id: 476,
    title: "Is there a minimum order value?",
    description:
      "We have no minimum order value and you can order for any amount. ",
  },
  {
    id: 477,
    title: "Do you charge for delivery?",
    description:
      "Delivery fee varies from city to city and is applicable if order value is below a certain amount. Additionally, certain restaurants might have fixed delivery fees. Delivery fee (if any) is specified on the 'Review Order' page. ",
  },
  {
    id: 478,
    title: "How long do you take to deliver?",
    description:
      "Standard delivery times vary by the location selected and prevailing conditions. Once you select your location, an estimated delivery time is mentioned for each restaurant.",
  },
  {
    id: 479,
    title: "What are your delivery hours?",
    description:
      "Our delivery hours vary for different locations and depends on availability of supply from restaurant partners.",
  },
  {
    id: 481,
    title: "Is single order from many restaurants possible?",
    description:
      "We currently do not support this functionality. However, you can place orders for individual items from different restaurants.",
  },
];
